import * as React from "react";
import "./styles.scss";
import { Typography } from "@mui/material";

const principles = [
  "Understand the operating workflow before writing software.",
  "Design products that managers and field teams can actually adopt.",
  "Build practical systems that can scale with the business.",
];

export default function AboutUs() {
  return (
    <main id="aboutUs">
      <section className="about-hero">
        <div className="inner-container about-grid">
          <div>
            <Typography className="eyebrow" variant="overline">
              About BRV
            </Typography>
            <Typography className="page-title" variant="h1">
              A technology partner for operational software products.
            </Typography>
          </div>
          <Typography className="lead" variant="body1">
            BR&V Technology PTE. LTD. designs and builds focused software for
            businesses that need clearer workflows, better reporting, and
            systems that support day-to-day operations.
          </Typography>
        </div>
      </section>

      <section className="about-content">
        <div className="inner-container content-grid">
          <article>
            <Typography variant="h2">What We Build</Typography>
            <Typography variant="body1">
              Our work spans ERP workspaces, payroll systems, point-of-sale
              products, agriculture tools, and industry-specific software. Each
              product is shaped around practical business use, not abstract
              technology for its own sake.
            </Typography>
          </article>
          <article>
            <Typography variant="h2">How We Work</Typography>
            <Typography variant="body1">
              We start by understanding the people, data, decisions, and
              handoffs inside an operation. From there, we design software that
              simplifies the work, improves visibility, and gives teams a more
              reliable way to move.
            </Typography>
          </article>
        </div>

        <div className="inner-container principle-list">
          {principles.map((item) => (
            <div key={item}>{item}</div>
          ))}
        </div>
      </section>
    </main>
  );
}
